import { render, staticRenderFns } from "./breeder-puppy-list-component.vue?vue&type=template&id=6135acaf&scoped=true&lang=pug"
import script from "./breeder-puppy-list-component.js?vue&type=script&lang=js&external"
export * from "./breeder-puppy-list-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-puppy-list-component.vue?vue&type=style&index=0&id=6135acaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135acaf",
  null
  
)

export default component.exports